import { render } from "./mobile.vue?vue&type=template&id=19b5ef0e&scoped=true&ts=true"
import script from "./mobile.vue?vue&type=script&lang=ts"
export * from "./mobile.vue?vue&type=script&lang=ts"

import "./mobile.vue?vue&type=style&index=0&id=19b5ef0e&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b5ef0e"]])

export default __exports__